import React from 'react'
import { useField } from '@morningtrain/react-fields'
import ForEachWeekday from 'support/helpers/ForEachWeekday'
import QuantityEditorField from 'support/fields/custom/QuantityEditorField'
import { Collection, ForEachModel, ModelContext, useModel, useValue } from '@morningtrain/react-resources'
import { StaticFilter } from '@morningtrain/react-filters'
import { Text } from '@morningtrain/react-displays'

export default function DepartmentNormsField (props) {
  const field = useField(props)
  const model = useModel()

  const WeekdayField = ({ weekday }) => {
    const departmentId = useValue('id')

    return (
      <ModelContext.Provider value={model}>
        <td className='py-3'>
          <QuantityEditorField
            min={0}
            name={[field.name, departmentId, weekday.index, 'norm_at_default'].join('.')}
            fromName={[field.fromName, departmentId, weekday.index, 'norm_at_default'].join('.')}
          />
        </td>
      </ModelContext.Provider>
    )
  }

  return field.wrap(() => (
    <table className='w-full'>
      <thead>
        <tr>
          <th className='text-left'>Department</th>
          <ForEachWeekday>
            {weekday => (
              <th>
                {weekday.name}
              </th>
            )}
          </ForEachWeekday>
        </tr>
      </thead>
      <tbody>
        <Collection resourceName='departments' operationName='select'>
          <StaticFilter name='is_production' value />
          <ForEachModel>
            <tr>
              <td>
                <Text name='name' />
              </td>
              <ForEachWeekday>
                {weekday => <WeekdayField weekday={weekday} />}
              </ForEachWeekday>
            </tr>
          </ForEachModel>
        </Collection>
      </tbody>
    </table>
  ))
}
